export default {
  colors: {
    primary: '#6078EA',
    background: '#FFFFFF',
    shape: `#F2F2FA`,
    title: `#3D3D4D`,
    text: `#6C6C80`,
  },
};